var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bread-cum',{attrs:{"breadcrumbItems":['รายการแทง', 'ยกเลิก โพย/รายการแทง']}})
}
var staticRenderFns = []

export { render, staticRenderFns }